<template>
  <div>
    <a-row>
      <a-col :span="4" />
      <a-col :span="14">
        <quill-editor ref="editor" />
        <div style="display: flex; margin-top: 10px">
          <span style="width: 70px; flex: none; line-height: 28px">通知标题：</span>
          <a-input v-model="remark" />
        </div>
        <div style="display: flex; margin-top: 10px">
          站点选择：
          <a-select v-model="site_id" style="width: 120px">
            <a-select-option v-for="(item, key) in siteOptions" :key="key" :value="key">
              {{ item }}
            </a-select-option>
          </a-select>
        </div>
        <div style="display: flex; margin-top: 10px">
          <span style="width: 70px; flex: none; line-height: 28px">文档链接：</span>
          <a-input v-model="doc_url" />
        </div>
        <div class="editor-button-box">
          <a-button @click="showNotice">展示</a-button>
          <a-button @click="finishCreate">完成</a-button>
        </div>
      </a-col>
      <a-col :span="4" />
    </a-row>
    <a-modal v-model="noticeVisible" title="展示" width="900px" :footer="null">
      <div class="ql-container ql-snow">
        <div class="ql-editor">
          <div v-html="content" />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { createNotice, getNoticeList, getSiteList, updateNotice } from '@/api/notice'
import quillEditor from '@/components/QuillEditor'

export default {
  components: { quillEditor },
  data() {
    return {
      content: '',
      remark: '',
      noticeVisible: false,
      pageType: 'create',
      siteOptions: {},
      site_id: '',
      doc_url: ''
    }
  },
  created() {
    this.pageType = this.$route.query.type
    if (this.pageType === 'update') {
      getNoticeList({ id: this.$route.query.id }).then(res => {
        const data = res.data.currentList[0]
        this.$refs.editor.setContent(data.content)
        this.remark = data.remark
        this.site_id = data.site_id + ''
        this.doc_url = data.doc_url
      })
    }
    getSiteList().then(res => {
      this.siteOptions = res.data.reduce((agg, e) => (agg[e.id] = e.name) && agg, {})
    })
  },
  methods: {
    finishCreate() {
      if (!this.$refs.editor.getContent() || !this.remark) {
        this.$message.warning('消息正文和消息描述不能为空', 2)
        return
      }
      if (!this.site_id) {
        this.$message.warning('请选择站点', 2)
        return
      }
      const params = {
        content: this.$refs.editor.getContent(),
        remark: this.remark,
        site_id: this.site_id,
        id: this.$route.query.id || '',
        doc_url: this.doc_url
      }
      let method = this.pageType === 'update' ? updateNotice : createNotice
      method(params).then(() => {
        this.$message.success(`${this.pageType === 'update' ? '更新' : '创建'}成功`, 2)
        this.$router.push({ name: 'NoticeManage' })
      })
    },
    showNotice() {
      this.content = this.$refs.editor.getContent()
      this.noticeVisible = true
    }
  }
}
</script>

<style scoped>
.editor-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.editor-button-box {
  margin-top: 20px;
  text-align: center;
}

.editor-button-box button {
  margin-right: 10px;
}
</style>
